// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__UXlqM","active":"PopoverSharedStyle_active__Reg8M","backdrop":"PopoverSharedStyle_backdrop__bkp5z"};